/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { RatingService } from 'src/app/services/rating.service';
import { FormBuilder, FormGroup, FormControl, Validators,} from '@angular/forms';
import { SampleRequestService } from 'src/app/services/sample-request.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-rating-popup',
  templateUrl: './rating-popup.component.html',
  styleUrls: ['./rating-popup.component.scss'],
   providers: [ConfirmationService, MessageService]
})
export class RatingPopupComponent implements OnInit{
  ratingForm: FormGroup;
  successMessage= '';
  errorMessage = '';
  constructor(public ratingService: RatingService, private fb: FormBuilder,private _ssq:SampleRequestService,private confirmationService: ConfirmationService, private messageService: MessageService,) {
    this.ratingForm = this.fb.group({
      stars: new FormControl(5, Validators.required),
      comment: new FormControl(''),
      answers: this.fb.group({})  // ✅ Placeholder for dynamic questions
    });

   
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    try{
    this.ratingService.getRatingsQuestionsAndOptions('sample delivery').subscribe((questions:any) => {
      const answersGroup: { [key: string]: FormControl } = {}; 
      questions.question_dict_list.forEach((q:any) => {
        answersGroup[q.id.toString()] = new FormControl('', Validators.required);
      });

      // ✅ Explicitly cast answers to FormGroup
      this.ratingForm.setControl('answers', new FormGroup(answersGroup));
    });}
    catch(e){
      console.log("error =>",e)
    }
  }

  // ✅ Helper function to get 'answers' as a FormGroup
  get answersGroup(): FormGroup {
    return this.ratingForm.get('answers') as FormGroup;
  }
  submitRating(): void {
    if (!this.ratingService.stars) {
      this.errorMessage = 'Please answer all required questions.';
      return;
    }

  this.ratingService.inLineloading = true;
const ratingData = {
  stars: this.ratingService.stars,
  comment: this.ratingService.comment,
  answers: this.ratingService.responses
};
    this.ratingService.submitRatingSample(ratingData).subscribe((response:any) => {
      console.log("Response =>",response)
      this.successMessage = 'Thank you for your feedback!';
      this.ratingService.comment = '';
      this.ratingService.displayRating = false;
      this.ratingService.inLineloading = false;
    }, (error:any) => {
      this.ratingService.inLineloading = false;
      this.errorMessage = 'Failed to submit rating. Please try again.';
      this.messageService.add({
        severity: 'error',
        summary: 'Submission Failed',
        detail: error.error.error,
        life:3000000
      });
    });
  }
  closeRatingPopup(){
    this.ratingService.stars = 0;
    this.ratingService.comment = '';
    this.ratingService.responses = [];
    this.ratingService.displayRating = false;
  }
  doneRating(){
    this.ratingService.displayThankYou=false;
    this._ssq.getSampleOrders()
  }
}
